import { useContext } from "react";
// import { FormContextMA } from "../form-context";
import { DataField, H2, Section } from "./common-components";

export const ClinicalServiceType = ( {formType, patient, preAssessment} ) => {
  // const { patient, preAssessment } = useContext(FormContextMA);

  const formatVisitType = (visitType) => {
    if (!visitType) return "";
    // Backend value/description includes "Rural Pharmacy", but UI/docs should show "Rural"
    if (visitType === "Virtual - Remote (Rural Pharmacy)")
      return "Virtual - Remote(Rural)";
    return visitType;
  };

  return (
    <Section className="space-y-[0.0833333in]" formType = {formType}>
      <H2>Clinical Service Type</H2>
      <div className="grid grid-cols-3">
        <DataField
          label="Appointment Type"
          value={preAssessment?.appointmentType}
        />
        <DataField
          label="Visit Type"
          value={formatVisitType(preAssessment?.visitType)}
          noWrapValue={true}
        />
        <DataField label="Location Type" value={preAssessment?.locationType} />
        <DataField label="Attendee(s)" value={preAssessment?.attendeeType} />
        {preAssessment?.visitType?.startsWith("Virtual") && preAssessment?.virtualVisitReason && (
            <DataField 
              label="Reason" 
              value={preAssessment?.virtualVisitReason}
              className="ml-0"
            />
          )}
        {/* <DataField
          label="Attendee(s)"
          value={preAssessment?.attendees
            ?.map?.((attendeeId) => {
              const attendee = patient?.caregiver?.find?.(
                (cg) => cg.id === attendeeId
              );
              return attendee && attendee.firstName && attendee.lastName
                ? `${attendee?.firstName} ${attendee?.lastName}`
                : attendeeId;
            })
            ?.join?.(", ")}
        /> */}
      </div>
    </Section>
  );
};
